import React, { useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import 'moment/locale/es';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import { useServices } from '../../hooks/useServices';
import { ElijePago } from '../elige/ElijePago';

import { useHistory } from 'react-router-dom';
import { RedUnefon1 } from '../redes/RedUnefon1';
import { Unefon1 } from './Unefon1';
import { UnefonIlimitado2 } from './UnefonIlimitado2';
import { Unefon2 } from './Unefon2';
import { UnefonFlex } from './UnefonFlex';
import { RedIlimitado2 } from '../redes/RedIlimitado2';
import { RedUnefon2 } from '../redes/RedUnefon2';
import { RedFlex } from '../redes/RedFlex';
import { useEventos } from '../../hooks/useEventos';

export const OfertaYaActiva2 = React.memo(({ data1, lic, pag }) => {



	const { activaSas, activaKairos, guardarDatosPay, getBotonPago, getCODI } = useServices();
const { clicTiendas, clicPago } = useEventos();

	const history = useHistory();

	const [ofertas, setOfertas] = useState([]);
	const [licObjeto, setLIC] = useState();
	const [botn, setBotn] = useState(false);
	const [codi, setCodi] = useState(false);

	const ref = useRef();

	const redes = useRef();
    const legalTexto = useRef();
    const maximo = useRef();
	const alto = useRef(135);


	// const ofertaGuardada = localStorage.getItem('oa');
	const ofertaGuardada = pag.tsk_id;


	let reqLIC = {
		...lic
	}


	const handleClick2 = () => {
    	if(codi){
    		licObjeto.singlePaymentMethod = "01"; 
   	  }
         clicPago('tarjeta');
        history.push("/load", {paymentSelfServiceRequest: licObjeto});
            //console.log('objeto lic enviado: ', licObjeto);
      }

      const handleClick3 = () => {
    	  if(codi){
    		  licObjeto.singlePaymentMethod = "02"; 
    		  }
              clicPago('codi');
        history.push("/load", {paymentSelfServiceRequest: licObjeto});
            //console.log('objeto lic enviado: ', licObjeto);
      }

    const sendTagLocator = () => {
        clicTiendas();
          history.push("/locator");
    }

	const editLegal = () => {
		let tiene = false;
		let tiene1 = false;
		let textoLegal = data1.legal;
		//console.log('legal completo: ', textoLegal);
		const indice = textoLegal.indexOf('**');
		const indice1 = textoLegal.indexOf('*');
		
			data1.oferta.map((ofr)=>{
						ofr.beneficiosOferta.map((of)=>{
							
							if (of.benefitDescription.indexOf('**') > -1 || of.benefitQuantity.indexOf('**') > -1 )
							{ tiene = true;}
							
						});
						ofr.beneficiosBase.map((of)=>{
							if (of.benefitDescription.indexOf('*') > -1 || of.benefitQuantity.indexOf('*') > -1)
							{ tiene1 = true;}
						  
						});
						
					});
		
					if (tiene == false && data1.planId !== 4){
						textoLegal = textoLegal.slice(0, indice);
					}
					if (tiene1 == false){
						textoLegal = textoLegal.slice(indice, -1);
					}
					
				   
		const texto = textoLegal.replaceAll("|","\n");
		legalTexto.current =  `${texto}`;
   }

const getLen = () => {
   let lens= [];
data1.oferta.map((ofr)=>{
	lens = [...lens,ofr.beneficiosBase.length ]
});
const max = Math.max.apply(null, lens);
maximo.current= max;
}

//    planId :
// 1 - unefon ilimitado 1
// 2 - unefon 2
// 3 - unefon ilimitado 2
// 4 - unefon flex
const tipoOferta = (ofertaParam) => {
darEspacios(ofertaParam);
quitarEspacios(ofertaParam);
switch (data1.planId) {
	case 1:
		return <Unefon1  oferta1={ofertaParam}/>
	break;
	case 2:
		return <UnefonIlimitado2  oferta1={ofertaParam}/>
	break;
	case 3:
		return <Unefon2  oferta1={ofertaParam}/>
	break;
	case 4:
		return <UnefonFlex  oferta1={ofertaParam}/>
	break;
	default:
		console.log('no existe planId');
		break;
}
}

const altosRedes = (ofertaParam) => {
switch (data1.planId) {
	case 1:
		redes.current = <RedUnefon1/>
	break;
	case 2:
		alto.current = 130;
		redes.current = <RedIlimitado2/>
	break;
	case 3:
		alto.current = 175;
		redes.current = <RedUnefon2/>
	break;
	case 4:
		redes.current = <RedFlex/>
	break;
	default:
		console.log('no existe planId');
		break;
}
}

const quitarEspacios = (oferta) =>{
oferta.beneficiosBase.map((of)=>{
	of.benefitDescription = of.benefitDescription.replace(/\s*(.*?)\s*\*/g,'$1*');
});
}

const darEspacios = (oferta) =>{
oferta.beneficiosBase.map((of)=>{
	of.topupAmount = oferta.topupAmount;
	//le quito las comas que vienen entre dos digitos
	of.benefitQuantity = of.benefitQuantity.replace(/(\d),(?=\d)/g,'$1');
	//sustituyo las comas por coma y un espacio
   of.benefitQuantity = of.benefitQuantity.split(',').join(', ');
});
}

    
    async function verBotonPago(){
        const {enableButtonPayment} = await getBotonPago();
        if(enableButtonPayment ==1 ){
            setBotn(true);
        }else{
            setBotn(false);
        }
    }
    
    async function verBotonCodi(){
		let cod;
        const {value} = await getCODI(7);//7 es CODI ATT 8 es CODI UNEFON
		if(value == "0"){//0 es desactivado 1 es activado
			setCodi(false);
		}else{
			setCodi(true);
		}
    }

	

	const ordenarOfertas = () => {
        let promos = [];
        return new Promise((resolve,reject)=>{
           data1.oferta.map((ofr)=>{
            promos = [...promos, ofr.topupAmount];
            promos.sort(function(a, b){return a-b});
                ofr.beneficiosBase.map((of)=>{
                    ofr.validity = of.validity;
                });
            });
            ref.current = promos
            resolve();
        });
       
    }
	
	const ordenarOfertas2 = async () => {
		let promos1 = [];
		await ordenarOfertas();

		data1.oferta.map((ofr) => {
			
				if (ofertaGuardada === ofr.tskId) {
					ofr.seleccionado = true;
					promos1 = [ofr,...promos1]; 
				} else{
					promos1 = [ofr,...promos1]; 
				}
				
	
		});
		promos1.sort(function (a, b) {
			return a.topupAmount - b.topupAmount;
		  });
		setOfertas(promos1);
		//console.log('ofertas2: ', promos1);
	}

	async function guardaDataPay() {
				const cantidad = pag.topup_amount;
		const numero = data1.dn;
		const payloadBit = {
			"mdn": pag.mdn,
			"tskId": pag.tsk_id,
			"topupAmount": Number(cantidad),
			"redeemedTime": data1.fechaRedimido
		}

		const respuestaBitacora = await guardarDatosPay(payloadBit);
		if (respuestaBitacora) {
			const trans_id = pag.transaction_id;
			if (respuestaBitacora.status) {
				//console.log('error guardar bitacora:', respuestaBitacora);
				reqLIC = {
					...lic,
					"dn": Number(numero),
					"transactionExtId": trans_id + "",
					"chargeAmount": Number(cantidad),
				}
				reqLIC.paymentDetail[0].amount = Number(cantidad);
				setLIC(reqLIC);
			} else {
				reqLIC = {
					...lic,
					"dn": Number(numero),
					"transactionExtId": trans_id + "",
					"chargeAmount": Number(cantidad),
				}
				reqLIC.paymentDetail[0].amount = Number(cantidad);
				setLIC(reqLIC);
			}
		} else {
			//console.log('error guarda: ', respuestaBitacora);
		}

	}


	let fechaVigencia = data1.fechaVigencia;
	fechaVigencia = moment(fechaVigencia).locale('es').format('LL');



	useEffect(() => {
		altosRedes();
		ordenarOfertas2();
		editLegal();
verBotonCodi();
        getLen();
		verBotonPago();
		guardaDataPay();

	}, [data1])



	return (
		<div>
			
					
						<div className="promo activada">

							<div className="titulo">Ya activaste esta oferta</div>

							<p>Recuerda hacer tu recarga para que se vea reflejada</p>

							<FormControl component="fieldset" className="contenedorFormas animate__animated animate__fadeIn" >
								<RadioGroup row className="contenedorUnefon" >
									{
										ofertas.map((offer, i) => (

											<div className={offer.seleccionado === true ? "ofertaM2" : "ofertaM"} key={ i }  style={{height : maximo.current * alto.current +"px"}}>
                                           
                                           
                                            <div className="cantidadOferta">${offer.topupAmount}</div>
                                            { 
                                            data1.planId === 3 
                                                &&<>
                                                <div className='diasvigencia'>/{offer.validity}</div>
                                                </>
                                            }
                                            { 
                                            data1.planId === 4 
                                                &&<>
                                                <div className='diasvigencia'>/{offer.validity}</div>
                                                </>
                                            }
                                            {tipoOferta(offer)}
                                        </div>

										)
										)
									}
								</RadioGroup>
							</FormControl>

						</div>
						
						<div className="conteRedes">
                                {redes.current}
                   		</div>

						
						<div className="botoneraYa">
		                {
		                    botn && <div onClick={handleClick2} className="btn btnpagolinea animate__animated animate__flipInX">Recarga en línea</div>
		                }
		                {
		                	(botn && codi) && <div onClick={handleClick3} className="btn btnpagolinea animate__animated animate__flipInX">Recarga con CODI</div>
		                }
		                    <div  onClick={sendTagLocator} className="btn btnpagotienda animate__animated animate__flipInX" >Localiza puntos de recarga</div>
		                 
		                </div>
						<div className="legalRecarga">Recuerda que puedes realizar tu recarga en tu tienda favorita o en mi AT&T.</div>
        
						<div className="textoRedes">
							{legalTexto.current}
							<div>Consulta coberturas, términos y condiciones de la oferta en unefon.com.mx</div>
						</div>
					
					
			

		</div>
	)
})
